function Footer() {
  return <div />;
}
export default Footer;
